export function validateNC(code) {
  let str = code.toString();

  // validate the string length and value
  const strLen = str.length;
  const strVal = parseInt(str, 10);
  if (strLen < 8 || strLen > 10 || Number.isNaN(strVal) || strVal === 0) { return false; }

  // make sure the string is padded with zeros
  while (str.length < 10) str = `0${str}`;

  // invalidate consecutive arrangement of the same digit
  if (str.match(/^(\d)\1+$/g)) return false;

  const checkDigit = parseInt(str.slice(-1), 10); // rightmost digit
  str = str.slice(0, -1); // remove the check digit

  let sum = 0;

  for (let i = str.length; i > 0; i--) { sum += (i + 1) * str.substr(-i, 1); }

  // calculate sum modulo 11
  const mod = sum % 11;

  return (mod < 2 && mod === checkDigit) || (mod >= 2 && mod + checkDigit === 11);
}
